<template>
    <div class="scrollbar-wrapper">
        <a @click="goToToday()" id="go_to_today">Today</a>
        <div @click="calculatePosition" :id="barId" class="scrollbar">
            <div @mousedown="bindMouseDown" :id="sliderId" class="scrollbar-slider"></div>
        </div>
    </div>
</template>

<script>
    import scrollBus from './ScrollBus';

   

    export default {
        name: 'scrollbar', 
        data() {
            return{
                barId: '',
                sliderId: '',

            };
        },

       mounted: function () {
          document.onmouseup = this.clear

           


             scrollBus.$on('change', (msg) => {
              

                let startTop = msg * this.barHeight / 100


                if( document.getElementById(this.sliderId)){
                    document.getElementById(this.sliderId).style.top = startTop+'px';
                }
            });


            scrollBus.$on('scrollUpdate', (msg) => {
    
                let startTop = msg * this.barHeight / 100
                if( document.getElementById(this.sliderId)){       
                    document.getElementById(this.sliderId).style.top = startTop+'px';

                }
                
            }); 


             scrollBus.$on('firstLoad', (msg) => {
                let startTop = msg * this.barHeight / 100
                 if( document.getElementById(this.sliderId)){     
                    document.getElementById('go_to_today').style.top = startTop+'px';
                }

             }); 
        },
        methods: {

            goToToday(){

                scrollBus.$emit('gotToToday', ("coucou"));
            },
            bindMouseDown() {
          
                document.onmousemove = this.calculatePosition;

            },
            clear() {
              
                document.onmousemove = null;
              
            },
            calculatePosition(event) {
                var mousePos = event.clientY;
                var barOffset = document.getElementById(this.barId).getBoundingClientRect().top; 
              
               

                // Making the lowest point on the bar zero
                var absolutePosOnBar = mousePos - barOffset;
               
                // Half of the slider is insignificant for calculating
                // the length travelled by it. Hence - (this.sliderWidth / 2)
                let posOnBar = absolutePosOnBar - (this.slideHeight / 2);

                // The length of the bar actually used for calculation purposes
                var clickableAreaLength = this.barHeight - this.slideHeight 
              

 
                var slider = document.getElementById(this.sliderId);
                // The distance travelled as percentage
                // to be sent to the gallery component
                let percToSend = (posOnBar * 100 ) / clickableAreaLength;

                let displayPerc = posOnBar;

                // This is done to prevent the slider move behind
                // its "point 0"
                if ( displayPerc < 0) {
                    displayPerc = 0;
                }

                if(displayPerc > clickableAreaLength){
                    displayPerc = clickableAreaLength
                }


               

                scrollBus.$emit('change', (percToSend));

                if(slider){
                    slider.style.top = displayPerc + 'px';
                }
            },
            elementPos(el) { 
                var rect = el.getBoundingClientRect(),
	           // scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	            return rect.top + scrollTop;
            },
          
        },
        computed: {
            barHeight() {
                var bar = document.getElementById(this.barId);
                if(bar)
                return bar.offsetHeight;
            },
            slideHeight() {
                var slider = document.getElementById(this.sliderId);
                return slider.offsetHeight;
            },
           
        },
        created() {
            this.barId = Math.random().toString(36).substring(7);
            this.sliderId = Math.random().toString(36).substring(7);
        },
    };
</script>



// WEBPACK FOOTER //
// ScrollBar.vue?6e10e45c